module.exports = __webpack_public_path__ + "static/media/FB.25f39d4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ministries/FB.svg
// module id = 242
// module chunks = 0